<template>

  <div>

  
  <b-card>
  
    <BaseTable 
      :fields="fields" 
      :items="items" 
      :loading="loading" 
      :rows="pagination.total"
      :perPage="filter.size"
      :currentPage="filter.page"
      :handle-page-change="handlePageChange"
      :detail-item="detailItem"
      :edit-item="editItem"
      :delete-item="deleteItem"
      hide-update
    />
  
    <DetailLoan 
      :page-title="pageTitle"
      :result="detail" />
    
  </b-card>
  
  </div>
  
  </template>
  
  <script>
  import _ from "lodash";
  import Ripple from "vue-ripple-directive";
  
  import { LoanService } from '@/services/loan.service'
  
  import { BCard, BRow, BCol, BButton, BFormInput, BSpinner } from "bootstrap-vue";
  import { successNotification, errorNotification } from "@/auth/utils";
  import vSelect from "vue-select";
  
  import BaseTable from "@/components/BaseTable.vue";
  import DetailLoan from "@/components/Loan/DetailLoan.vue";
  
  export default {
    name: 'LoanPage',
  
    components: {
      BaseTable,
      BCard,
      BRow,
      BCol,
      BButton,
      BFormInput,
      BSpinner,
      vSelect,
      DetailLoan,
  },
  
    directives: {
      Ripple,
    },
  
    setup () {
      return {
        successNotification,
        errorNotification,
        BaseTable,
      };
    },
  
    data () {
      return {
        key: 'loan',
        pageTitle: 'Loan',
        items: [],
        detail: Object,
        error: false,
        loading: false,
        pagination: {
          total: 0
        },
        filter: {
          branchId: "",
          employeeId: "",
          startDate: "",
          endDate: "",
          page: 1,
          size: 10,
          loanColumn: 'CREATED_DATE',
          sortDirection: 'DESC',
        },
        fields: [
          {
            key: "no",
            label: "No",
            width: '50px',
          },
          {
            key: "employee",
            label: "Nama Karyawan",
            thClass: 'c-w-200'
          },
          {
            key: "product",
            label: "Produk",
            thClass: 'c-w-200'
          },
          {
            key: "term",
            label: "Jangka Waktu",
          },
          {
            key: "margin",
            label: "Margin",
          },
          {
            key: "loanAmount",
            label: "Nominal",
          },
          {
            key: "statusApproval",
            label: "Status",
          },
          {
            key: "actions",
            label: "Aksi",
            width: '200px'
          },
        ],
        editId: null,
        formPayload: Object,
        isLoadingEmployeeList: false,
        filterValue: null,
      }
    },
  
    methods: {
      cleanUpForm() {
        this.editId = null;
        this.formPayload = {
          title: '',
          description: '',
          file: '',
        };
      },
      filterData() {
        this.fetchData()
      },
      async fetchData () {
        this.prepareFilter()
        this.loading = true
        try {
          const { data } = await LoanService.findAll(this.filter)
          
          this.items = data.content
          this.pagination.total = data.total
        } catch (e) {
          
        } finally {
          this.loading = false
        }
      },
      detailItem(item) {
        this.detail = item;
        this.$bvModal.show('detail-'+ this.key + '-modal')
      },
      editItem(item) {
        this.editId = item.id;
        this.formPayload = {
          title: item.title,
          description: item.description,
        };
        this.showFormModal()
      },
      async createItem() {
        this.loading = true
      
        try {
          await LoanService.create(this.preparePayload())
          successNotification(this, "Success", `${this.pageTitle} berhasil dibuat!`);
          this.hideFormModal()
          this.fetchData()
        } catch (e) {
          this.error = e.message
          errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      async updateItem() {
        this.loading = true
      
        try {
          await LoanService.update(this.editId, this.preparePayload())
          successNotification(this, "Success", `${this.pageTitle} berhasil diubah!`);
          this.hideFormModal()
          this.fetchData()
        } catch (e) {
          this.error = e.message
          errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      deleteItem(item) {
        this.$swal({
          title: "Anda yakin?",
          text: "Anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then(async (result) => {
          if (result.value) {
            try {
              await LoanService.delete(item.id)
              successNotification(this, "Success", `${this.pageTitle} berhasil dihapus!`);
              this.hideFormModal()
              this.fetchData()
            } catch (e) {
              this.error = e.message
              errorNotification(this, "Oops!", e.message);
            } finally {
              this.loading = false
            }
          }
        });
      },
      getPayload(value) {
        if (value) {
          this.formPayload = value;
        }
      },
      prepareFilter() {
        for (const key in this.filter) {
          if (
            this.filter.hasOwnProperty(key) &&
            this.filter[key] != null
          ) {
            if (this.filter[key] == null || this.filter[key] == "") {
              delete this.filter[key]
            }
          }
        }
        return this.filter
      },
      preparePayload() {
        const form = new FormData();
        for (const key in this.formPayload) {
          if (
            this.formPayload.hasOwnProperty(key) &&
            this.formPayload[key] != null
          ) {
            form.append(key, this.formPayload[key]);
          }
        }
  
        return form;
      },
      showFormModal() {
        this.$bvModal.show(`form-${this.key}-modal`); 
      },
      hideFormModal() { 
        this.$bvModal.hide(`form-${this.key}-modal`); 
      },
      handlePageChange(value) {
        this.loading = true
        this.filter.page = value;
      },
    },
  
    created () {
      this.fetchData()
    }
  
  }
  
  </script>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  </style>
  